var module = angular.module('octopusApp.accounts');

module.directive('usernamePasswordAccount', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      account: '=model'
    },
    templateUrl: 'areas/accounts/views/username_password_account.html'
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/accounts/directives/username_password_account.js
// module id = 3236012302483336
// module chunks = 1